<template>
	<Transition>
		<div class="pop-bg" v-show="props.isShow" @click="emit('closeToast')">
			<div class="pop-box">
				<img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="emit('closeToast')">
				<h2 class="pop-title">{{ $t('友情提示') }}</h2>
				<div class="content">
					1.{{ $t('一方为一个接入，例如：1部手机或1台电脑接入计算为一方') }}<br>
					2.{{ $t('收费为后付费模式，以实际使用时长为准，预约没开不收费') }}<br>
					3.{{ $t('频繁预约而末能按时使用，该账号的预约功能会被限制使用') }}<br>
					4.{{ $t('计费标准：超过一小时的，按小时套餐计费，不足一小时部分按基本分钟计费。') }}<br>
          {{ $t('例如：预约1小时15分钟的会议，1小时按套餐价格计费，15分钟根据选择级别按分钟价格计费') }}
				</div>
				<div class="box-button">
					<div class="btn-confirm" @click="emit('closeToast')">{{ $t('确定') }}</div>
				</div>
			</div>
		</div>
	</Transition>
</template>
<script setup>
	import {onMounted, ref} from "vue";
	const props = defineProps(["isShow"]);
	const emit = defineEmits()
	const passShow = ref(true)

</script>
<style src="./friendlyReminder.css" scoped></style>
